<template>
    <div id="modal-act-proj-menu" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li v-if="item.proj_open_flg == '0'" class="list-group-item border-0" @click="projOff('1')">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comment-slash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">募集終了にする</span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="projShare">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-share-alt icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">共有</span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="projOff('2')">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-trash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">削除</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                item: {}
            }
        },
        watch: {
            getCmpProjOffStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('delItemFromList', {
                        listItem: 'id',
                        pageId: this.item.id
                    })
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getCmpProjOffStatus'])
        },
        methods: {
            openThis (item) {
                this.resetThis()
                this.item = item
                $('#modal-act-proj-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-act-proj-menu').modal('hide')
            },
            resetThis () {
                this.item = {}
            },
            projOff (flg) {
                this.$store.dispatch('cmpProjOff', {
                    id: this.item.id,
                    flg: flg
                })
            },
            projShare () {
                this.$parent.projShare(this.item)
                this.hideThis()
            }
        }
    }
</script>

<style>

</style>
